import { ButtonWithIcon, Button } from '@/components/atoms'
import { COLOR } from '@/utils/constants/colors'
import { SIZE } from '@/utils/constants/globalStyle'
import { Font } from 'pepsico-ds'
import { useFormContext } from "react-hook-form"
import { Dropdown } from "@/components/atoms"
import { TextInputField } from '@/components/molecules'
import { useIntl } from 'react-intl'
import { useState } from 'react'

const Item = ({ data, handleChange, handleDelete, index, activityOptions, selectedActivityIds }) => {
  const { formatMessage } = useIntl()
  const handleActivity = (value) => {
    const selectedActivity = value && value[0];
    if (selectedActivity) {
      handleChange(index, {
        ...data,
        activityID: selectedActivity.id,
        activityName: selectedActivity.displayText || selectedActivity.name
      })
    } else {
      handleChange(index, {
        ...data,
        activityID: '',
        activityName: ''
      })
    }
  }

  const getFilteredActivityOptions = () => {
    return activityOptions.filter(option => {
      const isSelectedInThisDropdown = option.id === data?.activityID
      const isSelectedInOtherDropdown = selectedActivityIds.includes(option.id) && !isSelectedInThisDropdown
      return !isSelectedInOtherDropdown
    })
  }

  const handleMultiplier = (value) => {
    if (value === undefined && data.multiplier !== 0) {
      return
    }

    const multiplier = value && value !== '' ? parseFloat(value) || 0 : 0

    if (data.multiplier !== multiplier) {
      handleChange(index, {
        ...data,
        multiplier: multiplier
      })
    }
  }

  return (
    <div className="flex w-full items-center h-12" data-testid="item">
      <div className='flex items-start gap-4'>
        <Dropdown
          placeholder={formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_SETUP_ACTIVITIES_PLACEHOLDER' })}
          isDark
          childList={getFilteredActivityOptions()}
          value={[{ id: data?.activityID || '', displayText: data?.activityName || '' }]}
          updateValue={handleActivity}
          isJsonWrap={false}
          preventTyping={true}
        />
        <TextInputField
          value={data?.multiplier || ''}
          updateValue={handleMultiplier}
          visible
          suffix="x"
          schema={{
            type: 'number',
            restrictDecimal: false
          }}
          uiSchema={{
            placeholder: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_SETUP_ACTIVITIES_TEXT_PLACEHOLDER' }),
            isDark: true,
          }}
        />
         {index > 0 ? (
        <Button
          handleButton={() => handleDelete(index)}
          uiSchema={{
            title: 'Delete',
            variant: 'tertiary',
            size: 'medium',
          }}
          style={{ marginBottom: '40px', marginLeft: '15px', alignSelf: 'center' }}
        />
      ) : null}
      </div>

    </div>
  )
}

export const ActivitiesSelector = ({ activities = [] }) => {
  const { formatMessage } = useIntl()
  const { setValue, getValues } = useFormContext();
  const formActivitiesFromForm = getValues('activities') || [];
  const [localActivities, setLocalActivities] = useState(formActivitiesFromForm);

  const activityOptions = activities.length > 0
    ? activities.map(activity => ({
        id: activity.id,
        displayText: activity.name,
      }))
    : [];

  const selectedActivityIds = localActivities
    .map(activity => activity.activityID)
    .filter(id => id && id !== '');

  const handleChange = (index, newValue) => {
    const updatedActivities = [...localActivities];
    updatedActivities[index] = newValue;

    setLocalActivities(updatedActivities);
    setValue('activities', updatedActivities, { shouldDirty: true, shouldValidate: true });
  }

  const handleDelete = index => {
    const nextActivities = localActivities.filter((_, currentIndex) => currentIndex !== index);
    setValue('activities', nextActivities, { shouldDirty: true, shouldValidate: true });
    setLocalActivities(nextActivities);
  }

  const createNewActivity = () => {
    const newActivity = {
      activityID: '',
      activityName: '',
      multiplier: 0
    };

    const nextActivities = [...localActivities, newActivity];

    setValue('activities', nextActivities, { shouldDirty: true, shouldValidate: true });
    setLocalActivities(nextActivities);
  }

  return (
    <>
      <Font variant="bold" size="body" textColorClass="text-white" className="mb-5">
        {formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_SETUP_ACTIVITIES_TITLE' })}
      </Font>
      {localActivities.map((activity, index) => (
        <Item
          data={activity}
          handleChange={handleChange}
          handleDelete={handleDelete}
          key={index}
          index={index}
          activityOptions={activityOptions}
          selectedActivityIds={selectedActivityIds}
        />
      ))}
      <ButtonWithIcon
        uiSchema={{
          className: 'flex items-center text-[#0069D7] border-none',
          title: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_SETUP_ADD_ACTIVITY' }),
          size: SIZE.SMALL,
          variant: COLOR.TERTIARY,
        }}
        iconLeading="add_box"
        handleButton={createNewActivity}
      />
    </>
  )
}
